import React, { useState, useEffect } from "react";
import MasterTable from "../common/MasterTable";
import CustomAlert from "../../helpers/CustomAlert";
import { axiosPostApi } from "../../helpers/interceptorServices";
import { apiList } from "../../helpers/apiList";
import Loader from "../Loader/Loader";
import OrderFilterModal from "./OrderFilterModal";
import { format, parse } from "date-fns";
import ProductDetailsModal from "./ProductDetailModal";
import FullStatement from "../transactionReport/FullStatement";
import DownloadReport from "../transactionReport/DownloadReport";
import { useSelector } from "react-redux";
import confetti from "canvas-confetti";
import CreateOrderModal from "./CreateOrderModal";
import CancelShipmentModal from "./CancelShipmentModal";
import HeaderWithBreadcrumb from "../common/HeaderWithBreadcrumb";
import SendToOemModal from "../orderCourierHub/SendToOemModal";
import SuccessModal from "../successModal/successModal";
import OrderTrackingModal from "./OrderTrackingModal";
import ConfirmOrderReceipt from "./ConfirmOrderReceipt";
import OrderStickerReceipt from "./OrderStickerReceipt";
import SendToDelhiveryModal from "../orderCourierHub/SendToDelhivery";
import MapTrackIdModal from "../../pages/Master/MapTrackId";
import SendToTrackonModal from "../orderCourierHub/SendToTrackon";
import SendToShreeMaruti from "../orderCourierHub/SendToShreeMaruti";
import SendToCarrierModal from "../orderCourierHub/SendToCarrier";
import FilterBar from "../common/FilterBar";
import {
  emptyOrderScopeFilters,
  fetchOrderFilterOptions,
  cascadeOrderFilterOptions,
  orderScopeOptionLabel,
} from "../../helpers/orderFilterOptions";

// Helper function to get date 7 days ago in YYYY-MM-DD format
const getLast7DaysDate = () => {
  const today = new Date();
  const sevenDaysAgo = new Date(today);
  sevenDaysAgo.setDate(today.getDate() - 7);

  const year = sevenDaysAgo.getFullYear();
  const month = String(sevenDaysAgo.getMonth() + 1).padStart(2, "0");
  const day = String(sevenDaysAgo.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

// Helper function to get today's date in YYYY-MM-DD format
const getTodayDate = () => {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0");
  const day = String(today.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const defaultFilterData = {
  retailerId: "",
  retailerName: "",
  consigneeName: "",
  consigneeMobile: "",
  fromDate: getLast7DaysDate(),
  toDate: getTodayDate(),
  ourWaybillNumber: "",
  expressType: "",
  search: "",
  ...emptyOrderScopeFilters,
};

// Picking a scope filter clears the ones below it (hub → LMBP → sub-LMBP → user).
// The LMBP pick is sent as retailerId, as the pop-up filter did.
const SCOPE_ORDER = ["hubCode", "retailerId", "subLmbpCode", "filterUserId"];

const EXPRESS_TYPE_OPTIONS = [
  { value: "air", label: "Air" },
  { value: "surface", label: "Surface" },
];

const OrderMaster = () => {
  const pageSize = 10;
  const { user } = useSelector((state) => state.auth);
  const [reportRequesting, setReportRequesting] = useState(false);

  const [noData, setNoData] = useState(false);
  const [editData, setEditData] = useState({});
  const [orderData, setOrderData] = useState([]);
  const [modalAction, setModalAction] = useState("");
  const [loading, setLoading] = useState(false);
  const [pageDetails, setPageDetails] = useState(null);
  const loggedInUserName = sessionStorage.getItem("username");
  const [currentPage, setCurrentPage] = useState(1);
  const [filterData, setFilterData] = useState(defaultFilterData);
  const [columnData, setColumnData] = useState("");
  const [rowData, setRowData] = useState(null);
  const [showProductDetail, setShowProductDetail] = useState(false);
  const [productDetail, setProductDetail] = useState([]);
  const [isModalOpenReport, setIsModalOpenReport] = useState(false);
  const [isModalOpenReportDown, setIsModalOpenReportDown] = useState(false);
  const [downloadReportData, setDownloadReportData] = useState([]);
  const [loadingFullSt, setLoadingFullSt] = useState(false);
  const [loadingDowRep, setLoadingDowRep] = useState(false);
  const [noDowRepData, setNoDowRepData] = useState(false);
  const [pageDowRepDetails, setPageDowRepDetails] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDelhiveryOpen, setIsDelhiveryOpen] = useState(false);
  const [ewaybillNumber, setEwaybillNumber] = useState("");
  const [openMapTrackIdModal, setOpenMapTrackIdModal] = useState(false);
  const [isCancelShipmentModalOpen, setIsCancelShipmentModalOpen] =
    useState(false);
  const [orderTrackModalOpen, setOrderTrackModalOpen] = useState(false);

  // New states for receipt modal
  const [showReceipt, setShowReceipt] = useState(false);
  const [receiptData, setReceiptData] = useState({});
  const [showSuccess, setShowSuccess] = useState(false);
  const [successMessage, setSuccessMessage] = useState(null);
  const [showSmallReceipt, setShowSmallReceipt] = useState(false);
  const [isTrackonOpen, setIsTrackonOpen] = useState(false);
  const [isShreeMarutiOpen, setIsShreeMarutiOpen] = useState(false);
  const [isShreeTirupatiOpen, setIsShreeTirupatiOpen] = useState(false);

  const closeTrackonModal = () => {
    setIsTrackonOpen(false);
  };

  const openTrackonModal = () => {
    setIsTrackonOpen(true);
  };

  const closeShreeTirupati = () => {
    setIsShreeTirupatiOpen(false);
  };

  const openShreeTirupatiModal = () => {
    setIsShreeTirupatiOpen(true);
  };

  const closeShreeMaruti = () => {
    setIsShreeMarutiOpen(false);
  };

  const openShreeMarutiModal = () => {
    setIsShreeMarutiOpen(true);
  };

  const openModalReport = () => {
    setIsModalOpenReport(true);
  };

  const closeModalReport = () => {
    setIsModalOpenReport(false);
  };

  const openModalReportDown = () => {
    setIsModalOpenReportDown(true);
  };

  const closeModalReportDown = () => {
    setIsModalOpenReportDown(false);
  };

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const openDelhiveryModal = () => {
    setIsDelhiveryOpen(true);
  };

  const closeDelhiveryModal = () => {
    setIsDelhiveryOpen(false);
  };

  const handleReset = () => {
    setFilterData(defaultFilterData);
    fetchOrderData(1, defaultFilterData);
  };

  const [isModalOpenCreate, setIsModalOpenCreate] = useState(false);
  const openModalCreate = () => {
    setIsModalOpenCreate(true);
  };

  const [isModalOpenFilter, setIsModalOpenFilter] = useState(false);
  const openModalFilter = () => {
    setIsModalOpenFilter(true);
  };

  const closeModalFilter = () => {
    setIsModalOpenFilter(false);
  };

  // New handler for opening receipt from CreateOrderModal
  const handleOpenReceipt = (data) => {
    setReceiptData(data);
    setShowReceipt(true);
  };

  // New handler for closing receipt
  const handleCloseReceipt = () => {
    setShowReceipt(false);
  };

  const handleCloseSmallReceipt = () => {
    setShowSmallReceipt(false);
  };

  useEffect(() => {
    fetchOrderData(1, filterData);
  }, []);

  const [scopeOptions, setScopeOptions] = useState(null);
  useEffect(() => {
    if (user?.data?.userProfile !== "CUSTOMER") {
      fetchOrderFilterOptions().then(setScopeOptions);
    }
  }, []);

  const scopeLists = cascadeOrderFilterOptions(scopeOptions, {
    hubCode: filterData.hubCode,
    lmbpCode: filterData.retailerId,
    subLmbpCode: filterData.subLmbpCode,
  });

  const scopeSelect = (key, list, valueKey, allLabel, chipLabel) =>
    list?.length
      ? [
          {
            key,
            allLabel,
            chipLabel,
            options: list.map((item) => ({
              value: item[valueKey],
              label: orderScopeOptionLabel(item, valueKey),
            })),
          },
        ]
      : [];

  const handleFilterChange = (next) => {
    const changed = SCOPE_ORDER.findIndex(
      (k) => (next[k] || "") !== (filterData[k] || ""),
    );
    const values = { ...next };
    if (changed >= 0) SCOPE_ORDER.slice(changed + 1).forEach((k) => (values[k] = ""));
    setFilterData(values);
    setCurrentPage(1);
    fetchOrderData(1, values);
  };

  const fetchOrderData = async (currentPage, filters = filterData) => {
    setLoading(true);

    try {
      const requestBody = {
        username: loggedInUserName,
        retailerId: filters.retailerId || "",
        // retailerName: filters.retailerName || "",
        consigneeName: filters.consigneeName || "",
        consigneeMobile: filters.consigneeMobile || "",
        fromDate: formatDate(filters.fromDate),
        toDate: formatDate(filters.toDate),
        ...(user?.data?.userProfile === "HUB"
          ? { status: ["BAG_OPENED", "READY_TO_SEND", "FAILED", "SENT"] }
          : { status: [] }),
        ...(user?.data?.userProfile === "OPERATION" && filters.ourWaybillNumber
          ? { ourWaybillNumber: filters.ourWaybillNumber }
          : {}),
        expressType: filters.expressType || "",
        search: filters.search || "",
        hubCode: filters.hubCode || "",
        subLmbpCode: filters.subLmbpCode || "",
        filterUserId: filters.filterUserId || "",
      };

      const response = await axiosPostApi(
        `${apiList.FETCH_ORDER_MASTER_DATA}?pageSize=${pageSize}&pageNo=${currentPage}`,
        requestBody,
      );
      if (
        response?.data?.status === true &&
        response?.data?.respCode === "00"
      ) {
        setPageDetails(response?.data?.pageDetails);
        let modifiedData = modifyStructure(response?.data?.data);
        if (filters.consigneeName && filters.consigneeName.trim() !== "") {
          const query = filters.consigneeName.trim().toLowerCase();
          modifiedData = modifiedData.filter((item) =>
            (item?.consigneeName || "").toLowerCase().includes(query)
          );
        }
        setOrderData(modifiedData);
        setNoData(modifiedData?.length === 0);
        setEwaybillNumber(response?.data?.data?.[0]?.ewaybillNumber || "");
      } else {
        setNoData(true);
        setOrderData([]);
        // CustomAlert({
        //   title: "Failed",
        //   text: response?.data?.message || "Failed to fetch data",
        //   icon: "error",
        //   confirmButtonText: "Retry",
        // });
      }
    } catch (error) {
      setNoData(true);
      setOrderData([]);
      CustomAlert({
        title: "Error",
        text: "An error occurred while fetching the data. Please try again later.",
        icon: "error",
        confirmButtonText: "Retry",
      });
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const [year, month, day] = dateStr.split("-");
    return `${day}-${month}-${year}`;
  };

  const modifyStructure = (response) => {
    const modified = response?.map((user, index) => {
      const formattedCreDate = user?.createdDate
        ? parse(user.createdDate, "dd-MM-yyyy HH:mm:ss", new Date())
        : null;

      const formatAmount = (value) => {
        if (value === undefined || value === null || value === "") return "";
        return Number(value).toLocaleString("en-IN", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
      };

      return {
        ...user,

        remark: user?.cancelRemark ?? user?.cancelReason ?? "-",

        // Admin-only LMBP margin split (the API leaves it empty for other users)
        marginDisplay:
          Number(user?.marginAmount) > 0
            ? `${Number(user.marginAmount).toFixed(2)} (${Number(user.marginPercent)}%)`
            : "-",
        marginCompanyDisplay:
          Number(user?.marginCompanyAmount) > 0 ? Number(user.marginCompanyAmount).toFixed(2) : "-",
        marginLmbpDisplay:
          Number(user?.marginLmbpAmount) > 0
            ? `${Number(user.marginLmbpAmount).toFixed(2)} → ${user.marginLmbpCode} (${
                { PAID: "paid", PENDING: "on delivery", REVERSED: "reversed" }[user.marginLmbpStatus] ||
                user.marginLmbpStatus
              })`
            : "-",

        createdDate: formattedCreDate
          ? [
              format(formattedCreDate, "dd-MM-yyyy"),
              <br key={index} />,
              format(formattedCreDate, "HH:mm:ss"),
            ]
          : "",

        codAmount: (
          <div
            style={{
              width: "111px",
              textAlign: "end",
              whiteSpace: "nowrap",
            }}
            title={formatAmount(user.codAmount)}
          >
            {formatAmount(user.codAmount)}
          </div>
        ),

        orderAmount: (
          <div
            style={{
              width: "111px",
              textAlign: "end",
              whiteSpace: "nowrap",
            }}
            title={formatAmount(user.orderAmount)}
          >
            {formatAmount(user.orderAmount)}
          </div>
        ),

        gst: (
          <div
            style={{
              width: "101px",
              textAlign: "end",
              whiteSpace: "nowrap",
            }}
            title={formatAmount(user.gst)}
          >
            {formatAmount(user.gst)}
          </div>
        ),

        gstAmount: (
          <div
            style={{
              width: "111px",
              textAlign: "end",
              whiteSpace: "nowrap",
            }}
            title={formatAmount(user.gstAmount)}
          >
            {formatAmount(user.gstAmount)}
          </div>
        ),

        fuelCharges: (
          <div
            style={{
              width: "111px",
              textAlign: "end",
              whiteSpace: "nowrap",
            }}
            title={formatAmount(user.fuelCharges)}
          >
            {formatAmount(user.fuelCharges)}
          </div>
        ),

        amount: (
          <div
            style={{
              width: "100px",
              textAlign: "end",
              whiteSpace: "nowrap",
            }}
            title={formatAmount(user.amount)}
          >
            {formatAmount(user.amount)}
          </div>
        ),

        totalCharges: (
          <div
            style={{
              width: "111px",
              textAlign: "end",
              whiteSpace: "nowrap",
            }}
            title={formatAmount(user.totalCharges)}
          >
            {formatAmount(user.totalCharges)}
          </div>
        ),

        date: format(formattedCreDate, "dd-MM-yyyy"),

        orderAmountE: user?.orderAmount,
        gstE: user?.gst,
        createdDateE: user?.createdDate,
        codAmountE: user?.codAmount,
      };
    });

    return modified;
  };

  const getOrderHeaders = () => {
    const headers = [
      "Status",
      ...(user?.data?.userProfile !== "CUSTOMER"
        ? ["Response", "LMBP Id", "LMBP Name"]
        : []),
      "Consignee Name",
      "Mobile No",
      "Pincode",
      "City",
      "State",
      "Address",
      "Invoice Number",
      "Payment Mode",
      "Express Type",
      "Order Amount (₹)",
      "GST Rate (%)",
      "GST Amount (₹)",
      "Fuel Charges (₹)",
      "Base Amount (₹)",
      "Total Charges (₹)",
      ...(user?.data?.userProfile === "OPERATION"
        ? ["Margin (₹)", "Company Margin (₹)", "Parent LMBP Margin (₹)"]
        : []),
      ...(user?.data?.userProfile !== "CUSTOMER" ? ["COD Amount (₹)"] : []),
      "Pick Address",
      "Return Address",
      ...(user?.data?.userProfile === "OPERATION"
        ? ["Seller ID", "Route Code"]
        : []),

      "E-Way Bill Number",
      // OPERATION or HUB
      ...(user?.data?.userProfile === "OPERATION" ||
      user?.data?.userProfile === "HUB"
        ? ["Waybill", "OEM Name"]
        : []),
      "Created Date",
      "Remark",
    ];

    return headers;
  };

  const getOrderHeaderToKeyMap = () => {
    const baseMap = {
      Status: "orderStatus",
      Response: "response",
      "LMBP Id": "retailerId",
      "LMBP Name": "retailerName",
      "Consignee Name": "consigneeName",
      "Mobile No": "consigneeMobile",
      Pincode: "consigneePincode",
      City: "consigneeCity",
      State: "consigneeState",
      Address: "consigneeFullAddress",
      "Invoice Number": "invoiceNumber",
      "Payment Mode": "paymentMode",
      "Express Type": "expressType",
      "Order Amount (₹)": "orderAmount",
      "GST Rate (%)": "gst",
      "GST Amount (₹)": "gstAmount",
      "Fuel Charges (₹)": "fuelCharges",
      "Base Amount (₹)": "amount",
      "Total Charges (₹)": "totalCharges",
      "Margin (₹)": "marginDisplay",
      "Company Margin (₹)": "marginCompanyDisplay",
      "Parent LMBP Margin (₹)": "marginLmbpDisplay",
      "COD Amount (₹)": "codAmount",
      "Pick Address": "pickAddressTitle",
      "Return Address": "returnAddressTitle",
      "E-Way Bill Number": "ourWaybillNumber",
      Waybill: "waybill",
      "OEM Name": "carrier",
      "Created Date": "createdDate",
      Remark: "remark",
    };

    // Add conditional keys for OPERATION profile
    if (user?.data?.userProfile === "OPERATION") {
      baseMap["Seller ID"] = "sellerId";
      baseMap["Route Code"] = "routeCode";
    }

    return baseMap;
  };

  const handleAuthorization = (data) => {
    console.log("::data::", data);
  };

  const handleCustomer = (data, actionType = "view") => {
    setModalAction(actionType);
    setColumnData(data);

    if (actionType === "add") {
      setEditData({});
      openModalCreate(true);
      setIsModalOpenCreate(true);
    } else if (actionType === "cancelShipment") {
      setIsCancelShipmentModalOpen(true);
    } else if (actionType === "auth") {
      let custData = orderData.find((item) => item?.id === data?.id);
      if (custData) {
        setEditData(custData);
        setIsModalOpenCreate(true);
      }
    } else if (actionType === "productDetails") {
      handleProductDetails(data);
    } else if (actionType === "send") {
      // Check if shipmentWeight is less than 0.5
      if (data?.shipmentWeight < 0.5) {
        CustomAlert({
          title: "Info",
          text: "Weight should be greater than 0.5 to send to OEM.",
          icon: "info",
          confirmButtonText: "OK",
        });
      } else {
        openModal();
      }
    } else if (actionType === "trackOrder") {
      setOrderTrackModalOpen(true);
    } else if (actionType === "reSend") {
      handleResendOrder(data);
    } else if (actionType === "sticker") {
      setShowSmallReceipt(true);
    } else if (actionType === "printLabel") {
      const source = data?.orderSubmitSource;
      if (source === "SHYPME") {
        CustomAlert({
          title: "Info",
          text: "Printing is not available.",
          icon: "info",
          confirmButtonText: "OK",
        });
        return;
      }

      handlePrintCourierLabel(data?.id, source);
    } else if (actionType === "mapTrackId") {
      setOpenMapTrackIdModal(true);
    } else if (actionType === "cancelOrder") {
      let custData = orderData.find((item) => item?.id === data?.id);
      if (custData) {
        setEditData(custData);
        setIsModalOpenCreate(true);
      }
    } else if (actionType === "directToDelhivery") {
      openDelhiveryModal();
    } else if (actionType === "sendToTrackon") {
      openTrackonModal();
    } else if (actionType === "sendToShreeMaruti") {
      openShreeMarutiModal();
    } else if (actionType === "sendToShreeTirupati") {
      openShreeTirupatiModal();
    } else if (actionType === "downloadInvoice") {
      if (data) {
        const codCharges =
          data?.paymentMode === "COD"
            ? data.codAmount > 2000
              ? data.codAmount * 0.015
              : 30
            : 0;

        const preparedReceiptData = {
          // Header Details
          companyName: data?.creatorName || "N/A",

          companyAddress: `${data?.customerAddress1 || ""} ${
            data?.customerAddress2 || ""
          } ${data?.customerAddress3 || ""}`,

          companyContact: data?.creatorMobile
            ? `Phone: ${data.creatorMobile}${
                data.creatorEmail ? ` / Email: ${data.creatorEmail}` : ""
              }`
            : "Contact not available",

          // Receipt Left Details
          receiptNumber: data?.id,
          receiptDate: data?.createdDateE || "N/A",

          customerName: data?.consignorName || "N/A",
          customerContact: data?.consignorMobile || "N/A",

          customerAddress: `${data?.consignorAddress1 || ""} ${
            data?.consignorCity || ""
          } ${data?.consignorState || ""} ${data?.consignorPincode || ""}`,

          // Receipt Right Details
          orderId: data?.id,
          ourWaybillNumber: data?.ourWaybillNumber,

          consigneeName: data?.consigneeName,
          consigneeContact: data?.consigneeMobile,

          pickupLocation: data?.pickFullAddress || "N/A",

          deliveryAddress: `${data?.consigneeAddress1 || ""} ${
            data?.consigneeCity || ""
          } ${data?.consigneeState || ""} ${data?.consigneePincode || ""}`,

          returnAddress: data?.returnFullAddress,

          // Receipt Order Details
          productRows:
            data?.products?.map((prod) => ({
              description: `${prod.productName} (${
                prod.productCategory || ""
              })`,
              quantity: prod?.productQuantity,

              weight: prod?.productQuantity
                ? (
                    parseFloat(data?.shipmentWeight || 0) /
                    parseInt(prod?.productQuantity)
                  ).toFixed(2)
                : "0.00",

              pricePerUnit: parseFloat(prod?.productValue || 0).toFixed(2),

              total: (
                parseInt(prod?.productQuantity || 0) *
                parseFloat(prod?.productValue || 0)
              ).toFixed(2),
            })) || [],

          // Receipt Left Payment Details
          amount: data?.amount,
          fuelCharges: data?.fuelCharges,
          gstPercent: data?.gstE,
          gstAmount: data?.gstAmount,

          // Receipt Right Payment Details
          weight: data?.chargedWeight,
          codAmount: data?.codAmount,

          totalAmount: (data?.totalCharges || 0) + codCharges,
          expressType: data?.expressType || "N/A",
          lmbpBusinessType: data?.lmbpBusinessType,
          downloadInvoice: true,
        };

        handleOpenReceipt(preparedReceiptData);
      }
    } else {
      let custData = orderData.find((item) => item?.id === data?.id);
      if (custData) {
        setEditData(custData);
        setIsModalOpenCreate(true);
      }
    }
  };

  const pageSizeCount = pageDetails === null ? 0 : pageDetails.pageSize;
  const totalRecord = pageDetails === null ? 0 : pageDetails.totalRecords;

  const handleProductDetails = (data) => {
    if (data?.products && data?.products.length > 0) {
      setProductDetail(data?.products);
    } else {
      setProductDetail([]);
    }
    setShowProductDetail(true);
  };

  const handleFullStatement = async (fromDate, toDate) => {
    try {
      setLoadingFullSt(true);
      const payload = {
        username: user?.data?.username,
        fromDate,
        toDate,
      };

      const response = await axiosPostApi(
        `${apiList.ORDER_MASTER_DOWNLOAD_HISTORY}`,
        payload,
      );

      if (response.status === 200 && response.data.status === true) {
        CustomAlert({
          title: "Success",
          text: response?.data?.message || "Success",
          icon: "success",
          confirmButtonText: "Ok",
        });
        closeModalReport();

        const canvas = document.createElement("canvas");
        canvas.style.position = "fixed";
        canvas.style.top = "0";
        canvas.style.left = "0";
        canvas.style.width = "100%";
        canvas.style.height = "100%";
        canvas.style.zIndex = "3000";
        document.body.appendChild(canvas);

        const confettiInstance = confetti.create(canvas, {
          resize: true,
          useWorker: true,
        });

        confettiInstance({
          particleCount: 250,
          spread: 100,
          origin: { y: 0.6 },
        });

        setTimeout(() => {
          document.body.removeChild(canvas);
        }, 3000);
      } else {
        setNoData(true);
        fetchOrderData(1, filterData);

        if (response?.data?.data !== null) {
          CustomAlert({
            title: "Failed",
            text: response?.data?.message || "Failed",
            icon: "error",
            confirmButtonText: "Retry",
          });
        }
      }
      setLoadingFullSt(false);
    } catch (error) {
      CustomAlert({
        title: "Error",
        text: "An error occurred while processing.",
        icon: "error",
        confirmButtonText: "Retry",
      }).then((result) => {
        if (result.isConfirmed) {
          sessionStorage.clear();
          window.location.href = "/";
        }
      });
      setLoadingFullSt(false);
    }
  };

  const handleDownloadReport = async (currentPage) => {
    setLoadingDowRep(true);
    setNoDowRepData(false);

    try {
      const requestBody = {
        username: user?.data?.username,
      };

      const response = await axiosPostApi(
        `${apiList.ORDER_MASTER_DOWNLOAD_HISTORY_LIST}?pageSize=${pageSize}&pageNo=${currentPage}`,
        requestBody,
      );

      if (response && response.data) {
        if (response.data.status === true && response.data.respCode === "00") {
          const downloadHistory = response.data.data;
          setPageDowRepDetails(response.data.pageDetails);
          setDownloadReportData(downloadHistory || []);

          if (!downloadHistory || downloadHistory.length === 0) {
            setNoDowRepData(true);
          } else {
            setNoDowRepData(false);
          }
        } else {
          setDownloadReportData([]);
          setNoDowRepData(true);

          CustomAlert({
            title: "Failed",
            text: response.data.message || "Failed to fetch data",
            icon: "error",
            confirmButtonText: "Retry",
          });
        }
      } else {
        setDownloadReportData([]);
        setNoDowRepData(true);
      }
    } catch (error) {
      console.error("Error fetching download history:", error);
      setDownloadReportData([]);
      setNoDowRepData(true);

      CustomAlert({
        title: "Error",
        text: "An error occurred while fetching the data. Please try again later.",
        icon: "error",
        confirmButtonText: "Retry",
      });
    } finally {
      setLoadingDowRep(false);
    }
  };

  const submitOrder = async ({
    orderId,
    api,
    courierName = null,
    shippingCharges = 0.00,
    chargedWeight = null,
    gstAmount = 0.00,
  }) => {
    const payload = {
      username: loggedInUserName,
      orderId,
      // courierName,
      ...(courierName && { courierName }),
      ...(shippingCharges && { shippingCharges }),
      ...(chargedWeight && { chargedWeight }),
      ...(gstAmount && { gstAmount }),
    };

    try {
      const response = await axiosPostApi(api, payload);

      if (response?.status === 200 && response?.data?.respCode === "00") {
        fetchOrderData(currentPage);
        setSuccessMessage(response?.data?.message);
        setShowSuccess(true);
        setIsModalOpen(false);
        closeModal();
        closeDelhiveryModal();
        closeTrackonModal();
        closeShreeMaruti();
        closeShreeTirupati();
      } else {
        CustomAlert({
          title: "Failed",
          text:
            response?.data?.message || "Invalid selection. Please try again!",
          icon: "error",
          confirmButtonText: "Retry",
        });
      }
    } catch (error) {
      console.log("Order submit failed", error);
      CustomAlert({
        title: "Error",
        text: "Something went wrong while submitting the order.",
        icon: "error",
      });
    }
  };

  const handleSelectCourierCompany = (courierName) => {
    submitOrder({
      orderId: columnData?.id,
      courierName,
      api: apiList.SUBMIT_ORDER_TO_OEM,
    });
  };

  const handleSendDirectToDelhivery = (data) => {
    const taxAmountData = data?.tax_data;
    const totalTaxAmount =
      taxAmountData?.CGST +
      taxAmountData?.IGST +
      taxAmountData?.SGST +
      taxAmountData?.krishi_kalyan_cess +
      taxAmountData?.service_tax +
      taxAmountData?.swacch_bharat_tax;

    submitOrder({
      orderId: columnData?.id,
      courierName: "DELHIVERY",
      shippingCharges: data?.total_amount,
      chargedWeight: columnData?.shipmentWeight,
      gstAmount: totalTaxAmount,
      api: apiList.SUBMIT_ORDER_TO_DIRECT_DELHIVERY,
    });
  };

  const handleSendDirectToTrackon = (data) => {
    submitOrder({
      orderId: columnData?.id,
      shippingCharges: data?.shippingCharges,
      chargedWeight: data?.chargedWeight,
      gstAmount: data?.gstAmount,
      api: apiList.SUBMIT_ORDER_TO_DIRECT_TRACKON,
    });
  };

  const handleSendDirectToShreeMaruti = (data) => {
    const baseAmount = (data?.shippingCharge || 0) + (data?.fuelCharges || 0);
    submitOrder({
      orderId: columnData?.id,
      shippingCharges: data?.shippingCharge,
      chargedWeight: data?.chargeableWeight,
      gstAmount: +(baseAmount * 0.18).toFixed(2), // TODO
      api: apiList.SUBMIT_ORDER_TO_DIRECT_SHREE_MARUTI,
    });
  };

  const handleSendDirectToShreeTirupati = () => {
    submitOrder({
      orderId: columnData?.id,
      api: apiList.SUBMIT_ORDER_TO_SHREE_TIRUPATI,
    });
  };

  const handleResendOrder = async (data) => {
    const payload = {
      username: loggedInUserName,
      orderId: data?.id,
    };

    try {
      const response = await axiosPostApi(apiList.RESEND_ORDER, payload);
      if (response?.status === 200 && response?.data?.respCode === "00") {
        fetchOrderData(currentPage);
        setSuccessMessage(response?.data?.message);
        setShowSuccess(true);
      } else {
        CustomAlert({
          title: `Failed`,
          text:
            response.data?.message || "Invalid selection. Please try again!",
          icon: "error",
          confirmButtonText: "Retry",
        });
      }
    } catch (error) {
      console.log(`Failed to send courier selection.`);
      CustomAlert({
        title: "Error",
        text: "Please try again!",
        icon: "error",
        confirmButtonText: "Retry",
      });
    }
  };

  const directPrintPDF = (url) => {
    const printWindow = window.open(url, "_blank");

    if (!printWindow) return;

    const timer = setInterval(() => {
      try {
        printWindow.print();
        clearInterval(timer);
      } catch (e) {
        // wait until loaded
      }
    }, 500);
  };

  const handlePrintCourierLabel = async (orderId, courier) => {
    let url = "";

    if (courier === "TRACKON") url = apiList.TRACKON_PRINT_LABEL;
    else if (courier === "DIRECT_DELHIVERY")
      url = apiList.D_DELHIVERY_PRINT_LABEL;
    else if (courier === "DELCAPER") url = apiList.SHREE_MARUTI_PRINT_LABEL;

    const payload = {
      username: loggedInUserName,
      orderId,
    };

    try {
      const response = await axiosPostApi(url, payload);

      if (response?.status === 200 && response?.data?.respCode === "00") {
        const data = response?.data?.data;
        const labelUrl = data?.labelUrl;
        if (!labelUrl) throw new Error("Label URL missing");

        // 🖨️ DIRECT PRINT
        directPrintPDF(labelUrl);

        // Optional invoice printing
        // if (courier === "DELCAPER" && data?.invoiceUrl) {
        //   directPrintPDF(data.invoiceUrl);
        // }
      } else {
        CustomAlert({
          title: "Failed",
          text: response?.data?.message || "Label generation failed",
          icon: "error",
        });
      }
    } catch (err) {
      console.error("Print label error:", err);
      CustomAlert({
        title: "Error",
        text: "Unable to generate label",
        icon: "error",
      });
    }
  };

  // Large exports are generated in the background by the SendEmailUtility
  // OrderReportScheduler: queue the request here and download the file from
  // Report > Order Master once it is COMPLETED.
  const handleDownloadExcel = async () => {
    if (!filterData?.fromDate || !filterData?.toDate) {
      CustomAlert({
        title: "Select dates",
        text: "Please select From Date and To Date in the filter before downloading.",
        icon: "info",
        confirmButtonText: "OK",
      });
      return;
    }

    // The report scheduler (SendEmailUtility) only uses the date range and the
    // user's profile, so the other screen filters are not sent.
    const requestBody = {
      username: loggedInUserName,
      fromDate: formatDate(filterData?.fromDate),
      toDate: formatDate(filterData?.toDate),
    };

    setReportRequesting(true);
    try {
      const response = await axiosPostApi(
        apiList.ORDER_MASTER_DOWNLOAD_HISTORY,
        requestBody,
      );
      const ok =
        response?.data?.status === true && response?.data?.respCode === "00";
      CustomAlert({
        title: ok ? "Report requested" : "Failed",
        text:
          response?.data?.message ||
          "There was an issue processing the request.",
        icon: ok ? "success" : "error",
        confirmButtonText: "OK",
      });
    } catch (error) {
      CustomAlert({
        title: "Error",
        text: "Unable to request the report. Please try again later.",
        icon: "error",
        confirmButtonText: "OK",
      });
    } finally {
      setReportRequesting(false);
    }
  };

  return (
    <>
      <HeaderWithBreadcrumb title="Order Master" breadcrumb="Master" />
      <FilterBar
        values={filterData}
        onChange={handleFilterChange}
        search={{
          key: "search",
          placeholder: "Search waybill, tracking no., consignee name / mobile or LMBP",
        }}
        selects={[
          ...scopeSelect("hubCode", scopeLists.hubs, "code", "All hubs", "Hub"),
          ...scopeSelect("retailerId", scopeLists.lmbps, "code", "All LMBPs", "LMBP"),
          ...scopeSelect("subLmbpCode", scopeLists.subLmbps, "code", "All sub-LMBPs", "Sub-LMBP"),
          ...scopeSelect("filterUserId", scopeLists.users, "userId", "All users", "User"),
          { key: "expressType", allLabel: "All express types", chipLabel: "Express", options: EXPRESS_TYPE_OPTIONS },
        ]}
        dateRange={{ fromKey: "fromDate", toKey: "toDate", label: "Created" }}
      />
      <div className="bg-[#FFFFFF] shadow-custom rounded-[14px] px-[10px]">
        {loading ? (
          <Loader />
        ) : (
          <>
            <MasterTable
              loading={loading}
              headers={getOrderHeaders()}
              data={orderData}
              handleAction={handleCustomer}
              filterFields={["consigneeName"]}
              entityType="Order"
              headerToKeyMap={getOrderHeaderToKeyMap()}
              handleAuth={handleAuthorization}
              noData={noData}
              pageDetails={pageDetails}
              currentPage={currentPage}
              pageSize={pageSizeCount}
              totalRecord={totalRecord}
              fetchNextData={(page) => fetchOrderData(page, filterData)}
              setCurrentPage={setCurrentPage}
              openModalFilter={openModalFilter}
              handleReset={handleReset}
              filterData={filterData}
              fetchData={() => {}}
              handleProductDetails={handleProductDetails}
              setRowData={setRowData}
              openModalSms={openModalReport}
              openModalSmsDown={openModalReportDown}
              handleExport={handleDownloadExcel}
              exportLoading={reportRequesting}
              hideFilterControls
            />
          </>
        )}

        {isModalOpenFilter ? (
          <OrderFilterModal
            show={isModalOpenFilter}
            handleClose={closeModalFilter}
            setOrderData={setOrderData}
            setPageDetails={setPageDetails}
            setNoData={setNoData}
            currentPage={currentPage}
            pageSize={pageSize}
            filterData={filterData}
            setFilterData={setFilterData}
            handleReset={handleReset}
            user={user}
            orderDataList={orderData}
          />
        ) : null}

        {isModalOpenReport ? (
          <FullStatement
            handleopenReport={isModalOpenReport}
            handleCloseReport={closeModalReport}
            callApi={handleFullStatement}
            loading={loadingFullSt}
          />
        ) : null}
        {isModalOpenReportDown ? (
          <DownloadReport
            handleopenReportDown={isModalOpenReportDown}
            handleCloseReportDown={closeModalReportDown}
            callApi={handleDownloadReport}
            data={downloadReportData}
            pageDowRepDetails={pageDowRepDetails}
            noData={noDowRepData}
            loading={loadingDowRep}
          />
        ) : null}

        <ProductDetailsModal
          show={showProductDetail}
          handleClose={() => setShowProductDetail(false)}
          productDetail={productDetail}
        />

        {isModalOpenCreate && (
          <CreateOrderModal
            show={isModalOpenCreate}
            handleClose={() => setIsModalOpenCreate(false)}
            refreshTable={() => fetchOrderData(currentPage, filterData)}
            action={modalAction}
            editData={editData}
            columnData={columnData}
            onSuccess={handleOpenReceipt}
          />
        )}

        {isCancelShipmentModalOpen && (
          <CancelShipmentModal
            show={isCancelShipmentModalOpen}
            handleClose={() => setIsCancelShipmentModalOpen(false)}
            refreshTable={() => fetchOrderData(currentPage, filterData)}
          />
        )}

        {showReceipt && (
          <ConfirmOrderReceipt
            show={showReceipt}
            handleClose={handleCloseReceipt}
            receiptData={receiptData}
            ewaybillNumber={ewaybillNumber}
          />
        )}

        <OrderStickerReceipt
          show={showSmallReceipt}
          handleClose={handleCloseSmallReceipt}
          receiptData={columnData}
        />

        {isModalOpen && (
          <SendToOemModal
            show={isModalOpen}
            handleClose={() => closeModal()}
            callApi={handleSelectCourierCompany}
            columnData={columnData}
          />
        )}

        {isDelhiveryOpen && (
          <SendToDelhiveryModal
            show={isDelhiveryOpen}
            handleClose={() => closeDelhiveryModal()}
            callApi={handleSendDirectToDelhivery}
            columnData={columnData}
          />
        )}

        {isTrackonOpen && (
          <SendToTrackonModal
            show={isTrackonOpen}
            handleClose={() => closeTrackonModal()}
            callApi={handleSendDirectToTrackon}
            columnData={columnData}
          />
        )}

        {isShreeMarutiOpen && (
          <SendToShreeMaruti
            show={isShreeMarutiOpen}
            handleClose={() => closeShreeMaruti()}
            callApi={handleSendDirectToShreeMaruti}
            columnData={columnData}
          />
        )}

        {isShreeTirupatiOpen && (
          <SendToCarrierModal
            show={isShreeTirupatiOpen}
            handleClose={() => closeShreeTirupati()}
            callApi={handleSendDirectToShreeTirupati}
            columnData={columnData}
          />
        )}

        {orderTrackModalOpen && (
          <OrderTrackingModal
            show={orderTrackModalOpen}
            handleClose={() => setOrderTrackModalOpen(false)}
            columnData={columnData}
          />
        )}

        {showSuccess && (
          <SuccessModal
            show={true}
            handleClose={() => setShowSuccess(false)}
            successMessage={successMessage}
          />
        )}
        {openMapTrackIdModal && (
          <MapTrackIdModal
            open={openMapTrackIdModal}
            onClose={() => setOpenMapTrackIdModal(false)}
            columnData={columnData}
            callApi={() => fetchOrderData(currentPage, filterData)}
          />
        )}
      </div>
    </>
  );
};

export default OrderMaster;
